import { z } from 'zod';

export const AddressTypeZod = z.union([
    z.literal('domicile'),
    z.literal('homestead'),
    z.literal('mailing'),
    z.literal('billing'),
]);
